<header class="shadow">
  <app-header-public></app-header-public>
</header>
<section class="main-content-wrapper flex-fill pb-6">
  <router-outlet></router-outlet>
</section>

<footer>
  <app-footer-public></app-footer-public>
</footer>
